import {combineReducers} from "redux";
import ajouterAssignementUtilisateurCoursReducer from "./ajouterAssignementUtilisateurCours";
import supprimerAssignementUtilisateurCoursReducer from "./supprimerAssignementUtilisateurCours";


export default combineReducers({
    ajouterAssignementUtilisateurCours : ajouterAssignementUtilisateurCoursReducer,
    supprimerAssignementUtilisateurCours : supprimerAssignementUtilisateurCoursReducer
});